import { initImageLoader } from './loader';
import { initSmoothScroll, initFooterLinkFocus } from './scroll';
import { loadVideo } from './loader/video';
import type LocomotiveScroll from 'locomotive-scroll';

const onAbout = () => {
  return window.location.pathname.includes("about")
}

const getHashTargetOffset = () => {
  const styles = window.getComputedStyle(document.documentElement);
  const mobileOffset = styles.getPropertyValue('--header-offset-mobile').trim();
  const desktopOffset = styles.getPropertyValue('--header-height').trim();
  const activeOffset = window.innerWidth >= 768 ? desktopOffset : mobileOffset;
  const parsedOffset = Number.parseFloat(activeOffset);

  if (Number.isNaN(parsedOffset)) {
    return 0;
  }

  return parsedOffset;
};

const scrollToHashTarget = (scroll: LocomotiveScroll | null) => {
  const { hash } = window.location;

  if (!hash) {
    return;
  }

  const target = document.querySelector(hash);

  if (!(target instanceof HTMLElement)) {
    return;
  }

  const offset = getHashTargetOffset();

  // Recalculate Lenis scroll bounds after DOM swap
  if (scroll) {
    scroll.resize();
  }

  window.requestAnimationFrame(() => {
    if (scroll) {
      scroll.scrollTo(target, {
        duration: 0,
        offset: offset * -1,
      });
      return;
    }

    target.scrollIntoView({
      block: 'start',
      inline: 'nearest',
    });
  });
};

document.addEventListener('astro:page-load', async() => {
  console.log('Designed & Developed by N. Yasmeen');

  const smoothScroll = initSmoothScroll()
  await initImageLoader()

  if (onAbout())
    loadVideo();

  scrollToHashTarget(smoothScroll);
  initFooterLinkFocus(smoothScroll)
});
